function getPushStatusChecker(url, cb) {

    let id = "pushStatusChecker";
    let psc = document.querySelector("#" + id);
    if (psc) {
        return cb(psc);
    }

    psc = document.createElement("iframe");
    psc.src = url;
    psc.id = id;
    psc.style.display = "none";
    document.body.appendChild(psc);
    setTimeout(function() {
        cb(psc);
    }, 2000);
    setTimeout(function() {
        psc.parentNode.removeChild(psc);
    }, 4000);
}

export function checkPushStatus(url, cb) {

    getPushStatusChecker(url, function(psc) {

        let prevHandler = window.onmessage;
        let response;
        window.onmessage = function(e) {
            if(typeof e.data === "object"){
                response = Object.assign({}, e.data);
            }else{
                response = {
                    permission: false
                }
            }
            window.onmessage = prevHandler;
            cb(response);
        };
        psc.contentWindow.postMessage("checkPushStatus", "*");
    });
}

export function subscribeToChannels(channels, success, error){
    success = (typeof success == 'function') ? success : function(){};
    error = (typeof error == 'function') ? error : function(){};
    navigator.indigitall.subscribe(channels, success, error);
}


function success(success){
    Logger.debug(success);
}

function error(error){
    Logger.debug(error);
}


// WEBPACK FOOTER //
// ./src/scripts/layout/push-notification-indigitall.js